module.exports = __webpack_public_path__ + "static/media/search.f2c744c3.svg";